import './Freecart.css';
import React from 'react';
import Cartimage from '../Images/cart.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FreeCart = () => {
  const { t } = useTranslation();
  return (
    <div className="free-cart d-flex justify-content-center">
      <div className="container">
        <h2>{t('chart')}</h2>
        <div className="content">
          <img src={Cartimage} alt='' />
          <h3>{t('epmcartT1')}</h3>
          <p>{t('epmcartT2')}</p>
          <Link to="/">{t('epmcartT3')}</Link>
        </div>
      </div>
    </div>
  );
};

export default FreeCart;
